<div class="container">
  <span class="sopo-popup-title">Sorry</span>
  <div class="text-body">
    <div class="sopo-popup-text">This feature is not yet available in your region.
    <br><br>
    SOPO Sweepstakes & its features are only available in the U.S. states that permit sweepstakes. Please review <span class="terms-link" (click)="openAppBrowser('https://playsopo.com/#/terms-of-service/')">our terms</span> for more info.</div>
  </div>
  <div class="sopo-popup-blue-button" *ngIf="isElectron" (click)="recheck()">
      Recheck Location
  </div>
  <div class="sopo-popup-green-button" (click)="close()">
      Close
  </div>
</div>
